import { m } from "@estate-platform/i18n/messages";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";

import { AuthPending } from "../auth/auth-layout.tsx";
import { InvitePage } from "../auth/invite-page.tsx";
import { createInvitations } from "../data/invitation.ts";
import { followInvitationLanguage } from "../language/invitation-language.ts";

import type { ReactElement } from "react";

const route = getRouteApi("/invite/$token");

const tokenPattern = /^[\w\-]{40,64}$/v;

const Invite = (): ReactElement => (
  <InvitePage token={route.useParams().token} preview={route.useLoaderData()} />
);

export const Route = createFileRoute("/invite/$token")({
  loader: async ({ context, params }) => {
    const preview = tokenPattern.test(params.token)
      ? await createInvitations(context.data.client).preview(params.token)
      : null;
    if (preview !== null) {
      followInvitationLanguage(preview.language);
    }
    return preview;
  },
  pendingComponent: () => <AuthPending title={m.page_invite()} />,
  component: Invite,
});
